import { Link, LinkProps } from "@repo/next-utils/router";

export type ProductLinkProps = Omit<LinkProps, "href"> & {
  productName: string;
  productId: number | string;
  brandName?: string;
  fragments?: Record<string, string>;
};

function slugify(text: string): string {
  return text
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

export function ProductLink({
  productId,
  productName,
  brandName,
  fragments,
  ...props
}: ProductLinkProps) {
  let fragmentString = "";
  const name = slugify(productName);
  const brand = brandName ? `${slugify(brandName)}-` : "";

  if (fragments) {
    fragmentString = Object.entries(fragments)
      .map(([key, value]) => `#${key}-${value}`)
      .join("");
  }

  const href = `/product/${brand}${name}/${productId}${fragmentString}`;

  return <Link {...props} href={href} />;
}
